// Client mirror of supabase/functions/_shared/plans.ts — keep in sync.
export type Plan = "free" | "pro" | "ultra";

export const PLAN_LIMITS: Record<Plan, { designs: number; refines: number }> = {
  free: { designs: 1, refines: 3 },
  pro: { designs: 5, refines: 15 },
  ultra: { designs: 20, refines: 60 },
};

export const PLAN_LABELS: Record<Plan, string> = { free: "Free", pro: "Pro", ultra: "Ultra" };

export function planFromRow(row: { plan?: string | null; status?: string | null; current_period_end?: string | null } | null | undefined): Plan {
  if (!row || !["active", "trialing", "team", "referral"].includes(row.status ?? "")) return "free";
  if (row.status === "referral" && (!row.current_period_end || new Date(row.current_period_end) <= new Date())) return "free";
  return row.plan === "ultra" ? "ultra" : row.plan === "pro" ? "pro" : "free";
}
